import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import WpDynamicTable from "../../Components/WhatsappTable/WpDynamicTable";
import {
  AddWpSetupMain,
  DeleteWpSetupMain,
  fetchWpSetupAll,
  UpdateWpSetupMain,
} from "../../Redux/WhatsappSlice/WhatsappApiSetup";
import Loader from "../../Components/Loader/Loader";

const Wp_Setup_Main = () => {
  const dispatch = useDispatch();

  const { WpSetupData } = useSelector((state) => state.WpApiSetup);

  const [formData, setFormData] = useState({
    WhatsappOffcialName: "",
    OwnerNumber: "",
    Token: "",
    ApiURL: "",
    ApiVersion: "",
    WABAID: "",
    PhoneNumberID: "",
    SuccessKey: "",
  });

  useEffect(() => {
    dispatch(fetchWpSetupAll());
  }, [dispatch]);

  const [editId, setEditId] = useState(null);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = (formData) => {
    const errors = {};

    if (
      !formData.WhatsappOffcialName ||
      formData.WhatsappOffcialName.trim() === ""
    ) {
      errors.WhatsappOffcialName = "Whatsapp Official Name is required";
    }

    if (!formData.OwnerNumber || formData.OwnerNumber.trim() === "") {
      errors.OwnerNumber = "Owner Number is required";
    }

    if (!formData.Token || formData.Token.trim() === "") {
      errors.Token = "Token is required";
    }

    if (!formData.ApiURL || formData.ApiURL.trim() === "") {
      errors.ApiURL = "API URL is required";
    } else {
      // Validate URL format
      try {
        new URL(formData.ApiURL);
      } catch (err) {
        errors.ApiURL = "Invalid URL format";
      }
    }

    if (!formData.ApiVersion || formData.ApiVersion.trim() === "") {
      errors.ApiVersion = "API Version is required";
    }

    if (!formData.WABAID || formData.WABAID.trim() === "") {
      errors.WABAID = "WABA ID is required";
    }

    if (!formData.PhoneNumberID || formData.PhoneNumberID.trim() === "") {
      errors.PhoneNumberID = "Phone number is required";
    }

    if (!formData.SuccessKey || formData.SuccessKey.trim() === "") {
      errors.SuccessKey = "Success Key is required";
    }
    return errors;
  };

  const handleDelete = async (row) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete this item?`
    );
    if (!isConfirmed) return;

    try {
      await dispatch(DeleteWpSetupMain({ id: row.MainId })).unwrap();
      toast.success("Data deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
      dispatch(fetchWpSetupAll()); // refresh list
    } catch (error) {
      toast.error(`Failed to delete Data: ${error}`, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const handleEdit = (row) => {
    setEditId(row.MainId);
    setFormData({
      WhatsappOffcialName: row.WhatsappOffcialName,
      OwnerNumber: row.OwnerNumber,
      Token: row.Token,
      ApiURL: row.ApiURL,
      ApiVersion: row.ApiVersion,
      WABAID: row.WABAID,
      PhoneNumberID: row.PhoneNumberID,
      SuccessKey: row.SuccessKey,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (Object.keys(validationErrors).length === 0) {
      try {
        if (editId) {
          await dispatch(UpdateWpSetupMain({ id: editId, formData })).unwrap();
          toast.success("Whatsapp Api Data updated successfully!", {
            position: "top-right",
            autoClose: 1000,
          });
        } else {
          await dispatch(AddWpSetupMain({ values: formData })).unwrap();
          toast.success("Whatsapp Api Data added successfully!!", {
            position: "top-right",
            autoClose: 1000,
          });
        }

        // Reset form
        setFormData({
          WhatsappOffcialName: "",
          OwnerNumber: "",
          Token: "",
          ApiURL: "",
          ApiVersion: "",
          WABAID: "",
          PhoneNumberID: "",
          SuccessKey: "",
        });
        dispatch(fetchWpSetupAll());
      } catch (error) {
        toast.error(
          `Failed to ${editId ? "update" : "add"}  Whatsapp Api Data: ${
            error.message || "Unknown error"
          }`,
          {
            position: "top-right",
            autoClose: 1000,
          }
        );
      }
    } else {
      toast.error("Please fix validation errors.", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const columns = [
    { field: "id", headerName: "No", flex: 1 },
    {
      field: "WhatsappOffcialName",
      headerName: "Whatsapp Offcial Name",
      flex: 1,
    },
    { field: "OwnerNumber", headerName: "Owner Number", flex: 1 },
    { field: "Token", headerName: "Token", flex: 1 },
    { field: "ApiURL", headerName: "ApiURL", flex: 1 },
    { field: "ApiVersion", headerName: "Api Version", flex: 1 },
    { field: "WABAID", headerName: "WABAID", flex: 1 },
    { field: "PhoneNumberID", headerName: "PhoneNumberID", flex: 1 },
    { field: "SuccessKey", headerName: "Success Key", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <div className="flex space-x-2 justify-center">
          <button
            className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
            onClick={() => handleEdit(params.row)}
          >
            Update
          </button>
          <button
            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            onClick={() => handleDelete(params.row)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  //   const rows = WpSetupData?.map((el, index) => ({
  //     id: index + 1,
  //     MainId: el._id,
  //     WhatsappOffcialName: el?.WhatsappOffcialName,
  //     OwnerNumber: el?.OwnerNumber,
  //     Token: el?.Token,
  //     ApiURL: el?.ApiURL,
  //     ApiVersion: el?.ApiVersion,
  //     WABAID: el?.WABAID,
  //     ApiVersion: el?.ApiVersion,
  //     PhoneNumberID: el?.PhoneNumberID,
  //     SuccessKey: el?.SuccessKey,
  //   }));

  const rows = (WpSetupData || [])?.map((el, index) => ({
    id: index + 1,
    MainId: el._id,
    WhatsappOffcialName: el?.WhatsappOffcialName,
    OwnerNumber: el?.OwnerNumber,
    Token: el?.Token,
    ApiURL: el?.ApiURL,
    ApiVersion: el?.ApiVersion,
    WABAID: el?.WABAID,
    PhoneNumberID: el?.PhoneNumberID,
    SuccessKey: el?.SuccessKey,
  }));

  if (!WpSetupData ) {
    return <Loader />;
  }

  return (
    <>
      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            {editId ? "Update Wp Setup" : "Add Whatsapp Setup Main "}
            {/* Whatsapp Setup Main */}
          </h3>
        </div>

        <div className="Form_bg_color bg-white shadow-sm rounded-xl mt-4">
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-12 gap-4 p-3 rounded-2xl"
          >
            {/* WhatsApp Official Name Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">
                WhatsApp Official Name
              </h5>
              <input
                type="text"
                name="WhatsappOffcialName"
                // placeholder="Enter version number"
                value={formData.WhatsappOffcialName}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.WhatsappOffcialName && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.WhatsappOffcialName}
                </p>
              )}
            </div>

            {/* Owner Number Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Owner Number</h5>
              <input
                type="number"
                name="OwnerNumber"
                // placeholder="Enter version number"
                value={formData.OwnerNumber}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.OwnerNumber && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.OwnerNumber}
                </p>
              )}
            </div>

            {/* Token Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Token</h5>
              <input
                type="text"
                name="Token"
                // placeholder="Enter version number"
                value={formData.Token}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.Token && (
                <p className="text-red-500 text-sm mt-1">{errors.Token}</p>
              )}
            </div>

            {/* API URL Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">API URL</h5>
              <input
                type="text"
                name="ApiURL"
                // placeholder="Enter version number"
                value={formData.ApiURL}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.ApiURL && (
                <p className="text-red-500 text-sm mt-1">{errors.ApiURL}</p>
              )}
            </div>

            {/* API Version Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">API Version</h5>
              <input
                type="text"
                name="ApiVersion"
                // placeholder="Enter version number"
                value={formData.ApiVersion}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.ApiVersion && (
                <p className="text-red-500 text-sm mt-1">{errors.ApiVersion}</p>
              )}
            </div>

            {/* WABA ID Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">WABA ID</h5>
              <input
                type="text"
                name="WABAID"
                // placeholder="Enter version number"
                value={formData.WABAID}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.WABAID && (
                <p className="text-red-500 text-sm mt-1">{errors.WABAID}</p>
              )}
            </div>

            {/* Phone Number Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Phone Number</h5>
              <input
                type="number"
                name="PhoneNumberID"
                // placeholder="Enter version number"
                value={formData.PhoneNumberID}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.PhoneNumberID && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.PhoneNumberID}
                </p>
              )}
            </div>

            {/* Success Key Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Success Key</h5>
              <input
                type="text"
                name="SuccessKey"
                // placeholder="Enter version number"
                value={formData.SuccessKey}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
            </div>

            {/* Submit Button */}
            <div className="submit_Form col-span-12 flex justify-center">
              <button type="submit" className="All_button">
                {editId ? "Update" : "Submit"}
              </button>

              {editId && (
                <button
                  type="button"
                  className="bg-gray-500 text-white ms-2 px-4 py-2 rounded hover:bg-gray-600"
                  onClick={() => {
                    setFormData({
                      WhatsappOffcialName: "",
                      OwnerNumber: "",
                      Token: "",
                      ApiURL: "",
                      ApiVersion: "",
                      WABAID: "",
                      PhoneNumberID: "",
                      SuccessKey: "",
                    });
                    setEditId(null);
                    setErrors({});
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>

        <div className="px-2 py-6">
          <div className="title">
            <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block text-uppercase rounded">
              View Whatsapp API Setup
            </h3>
          </div>
          <div className="rounded-lg overflow-x-auto mt-3">
            <WpDynamicTable columns={columns} rows={rows} height="550px" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Wp_Setup_Main;
